import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>A CONTROL MODEL
                                            </div>
                                            <p>Collins English Dictionary defines control as <span
                                                className="brown brownbold">‘the power to direct something’</span>.
                                                Controlling
                                                situations at work is an important aspect of a manager’s job.
                                                You need to demonstrate an ability
                                                to control or direct a situation to achieve the best possible
                                                outcome for the business.</p>
                                            <p><span className="brown brownbold">‘A person’s ability to control his or her work activities’</span><a
                                                className="superscripttext"
                                                href="further_info.php?course=300"><sup>3</sup></a> as the
                                                theory tells us, requires
                                                knowledge of which skills are needed to achieve a particular
                                                result, an ability to make decisions
                                                – and the authority to do so. Simple, except when (and we’ve all
                                                been here) your team is
                                                unmotivated or you don’t have the authority to make a particular
                                                decision. Or perhaps you’re
                                                faced with an unusually tricky or ambiguous situation and your
                                                confidence in your own abilities
                                                suddenly evaporates! iLEAD™ is the very thing to help you in any
                                                of these circumstances…</p>
                                            <p>Lack of autonomy at work is a key ‘stressor’, especially when
                                                yours is a demanding job. Here’s a
                                                model of how control – or the lack of it – affects stress
                                                levels.<a className="superscripttext"
                                                          href="further_info.php?course=300"><sup>4</sup></a>
                                            </p>

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink">
                                                <tbody>
                                                <tr>
                                                    <th width="30%" align="left" valign="top"
                                                        className="green_curve" rowSpan="2">Control
                                                    </th>
                                                    <th width="50%" align="left" valign="top"
                                                        className=" green_curve1" colSpan="2">Demands
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <th width="20%" align="left" valign="top" className="">Low
                                                    </th>
                                                    <th width="20%" align="left" valign="top"
                                                        className=""> High
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="20%" align="left" valign="top"
                                                        className="subheading2bg"><p>High</p>
                                                    </td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Low strain</p>
                                                    </td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Active</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="20%" align="left" valign="top"
                                                        className="subheading2bg"><p>Low</p>
                                                    </td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>Passive</p>
                                                    </td>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen"><p>High strain</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <p>So, the optimum combination would be to have a demanding job plus
                                                a high degree of control
                                                over how you do it, which promotes ‘active learning’ (learning
                                                through doing). The most stressful
                                                combination is a demanding job with little control over how you
                                                do it.</p>
                                            <p>We want to help you gain greater control so that, depending on
                                                how demanding your job is, you
                                                are either less stressed or have more opportunity to ‘actively
                                                learn’. </p>

                                            <div className="border_subtitle">Here are two ways of taking control
                                                of a situation:
                                            </div>
                                            <ol className="brownbullet-list  listcontentSpacing paraspace"
                                                style={{marginBottom:'16px !important'}}>
                                                <li style={{paddingLeft:'0px !important'}}><p>Through direct,
                                                    personal control, using skills and resources to get the
                                                    desired outcomes.</p></li>
                                                <li style={{paddingLeft:'0px !important'}}><p>Through ‘socially
                                                    mediated, proxy control’, which means influencing others to
                                                    get the result
                                                    you want – you’ll need to be charming and/or persuasive for
                                                    that one!</p></li>

                                            </ol>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>LOCUS OF CONTROL
                                            </div>

                                            <p>Your ‘locus of control’ is one factor that will influence your
                                                direct personal control. Some people
                                                think what they do and the mistakes they make affect what
                                                happens to them, so they feel in
                                                control of outcomes. Others believe that fate plays a large part
                                                in what happens and that ‘what
                                                will be, will be’ no matter what they do. These feelings relate
                                                to their ‘locus of control’ which is
                                                best thought of in terms of a continuum:</p>
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/arrow-control.png')}
                                                    alt=""/>

                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}